import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import apiService from '../services/apiService';

const ManageSeller = () => {
  const [sellers, setSellers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchSellers();
  }, []);

  const fetchSellers = async () => {
    try {
      setLoading(true);
      
      const data = await apiService.get('/seller-companies');
      setSellers(data);
      setError(null);
    } catch (err) {
      console.error('Error fetching sellers:', err);
      setError('Failed to load sellers. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  const handleSellerClick = (sellerId) => {
    navigate(`/sellers/${sellerId}`);
  };

  if (loading) {
    return (
      <div className="manage-properties">
        <div className="page-header">
          <h1>Manage Sellers</h1>
        </div>
        <div className="loading-state">
          <p>Loading sellers...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="manage-properties">
        <div className="page-header">
          <h1>Manage Sellers</h1>
        </div>
        <div className="error-state">
          <p>{error}</p>
          <button type="button" onClick={fetchSellers} className="retry-button">
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="manage-properties">
      <div className="page-header">
        <h1>Manage Sellers</h1>
      </div>

      <div className="properties-table sellers-table">
        <div
          className="description-grid-shell description-grid-shell--sellers"
          role="table"
          aria-label="Sellers"
        >
          <div role="row" className="description-grid-row description-grid-head">
            <div role="columnheader" className="description-grid-cell description-grid-cell-head">
              ID
            </div>
            <div role="columnheader" className="description-grid-cell description-grid-cell-head">
              Company Name
            </div>
            <div role="columnheader" className="description-grid-cell description-grid-cell-head">
              Contact Person
            </div>
            <div role="columnheader" className="description-grid-cell description-grid-cell-head">
              Email
            </div>
            <div role="columnheader" className="description-grid-cell description-grid-cell-head">
              Phone
            </div>
            <div
              role="columnheader"
              className="description-grid-cell description-grid-cell-head description-grid-cell-description"
            >
              Description
            </div>
            <div role="columnheader" className="description-grid-cell description-grid-cell-head">
              Status
            </div>
          </div>

          {sellers.map((seller) => (
            <div role="row" className="description-grid-row" key={seller.id}>
              <div role="cell" className="description-grid-cell description-grid-cell-id">
                <strong>{seller.id}</strong>
              </div>
              <div role="cell" className="description-grid-cell description-grid-cell-tight">
                <a 
                  href="#"
                  className="property-link"
                  onClick={(e) => {
                    e.preventDefault();
                    handleSellerClick(seller.id);
                  }}
                  title="Click to edit seller details"
                >
                  {seller.companyName}
                </a>
              </div>
              <div role="cell" className="description-grid-cell description-grid-cell-tight">
                {seller.contactPerson}
              </div>
              <div
                role="cell"
                className="description-grid-cell description-grid-cell-email"
                title={seller.emailAddress || ''}
              >
                {seller.emailAddress}
              </div>
              <div role="cell" className="description-grid-cell description-grid-cell-tight">
                {seller.contactNumber}
              </div>
              <div role="cell" className="description-grid-cell description-grid-cell-description">
                {seller.description ?? 'No description'}
              </div>
              <div role="cell" className="description-grid-cell description-grid-cell-status">
                <span className={`status-badge ${seller.isActive ? 'active' : 'inactive'}`}>
                  {seller.isActive ? 'Active' : 'Inactive'}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ManageSeller;
